import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
import classNames from 'classnames';
import { forwardRef } from 'react';
export const IconIndicatorWrapper = forwardRef(({ children, type, className, style, htmlAttributes }, ref) => {
    const classes = classNames('ndl-icon-indicator-wrapper', className);
    return (_jsxs("div", Object.assign({ ref: ref, className: classes, style: style }, htmlAttributes, { children: [children, _jsx(IconIndicator, { type: type })] })));
});
const IconIndicator = ({ type = 'info' }) => {
    const classes = classNames('ndl-icon-indicator', {
        'ndl-danger': type === 'danger',
        'ndl-info': type === 'info',
        'ndl-warning': type === 'warning',
    });
    return (_jsx("svg", { width: "5", height: "5", viewBox: "0 0 5 5", fill: "none", xmlns: "http://www.w3.org/2000/svg", className: classes, children: _jsx("circle", { cx: "2.5", cy: "2.5", r: "2.5" }) }));
};
IconIndicatorWrapper.displayName = 'IconIndicatorWrapper';
//# sourceMappingURL=IconIndicatorWrapper.js.map